module.exports = __webpack_public_path__ + "img/centerCensus4.ee609493.png";